export default __webpack_public_path__ + "static/media/sign-in.12ce1dba.gif";